import { ICourseSearchAuthorizationModel } from '../models/course_search_authorization_model';

export class AuthorizationServant {
  getAuthorization(csrfToken: string, authToken: string): ICourseSearchAuthorizationModel['authorization'] {
    if (!authToken) {
      return {
        type: 'csrf',
        token: csrfToken
      };
    }
    return {
      type: 'token',
      token: authToken
    };
  }

  async getCookie(key: string) {
    const io = await window['$ip'].require('@eab-pip/pi-io');
    const cookie = await io.create('cookie').invoke(`/${key}`);
    return cookie.data;
  }

  async getCSRFToken() {
    return await this.getCookie('csrftoken');
  }
}

angular.module('capability-ng-scheduler').service('ngAuthorizationServant', AuthorizationServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/servants/authorization_servant.ts